import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  InputNumber,
  Row,
  Select,
  Spin,
  Table,
  Typography,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { connect } from "react-redux";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
const { Text, Title } = Typography;

const ReceiveTellerTransaction = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [transactionDetail, setTransactionDetail] = useState({});
  const [denominationForm] = Form.useForm();
  const [denominationEntries, setDenominationEntries] = useState([]);
  const [selectedDenominationValue, setSelectedDenominationValue] = useState(0);
  const [denominationCount, setDenominationCount] = useState(0);
  const transactionCurrency = "USD";

  useEffect(() => {
    if (!state?.id) {
      return;
    }
    // getDetailById(state.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.id]);

  const getDetailById = (id) => {
    setIsLoading(true);
    const url = `${apiConfig.Transactions}/${id}`;
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage || "Failed to fetch transaction detail");
      } else {
        setIsLoading(false);
        setTransactionDetail(res || {});
      }
    });
  };

  const detailValues = useMemo(
    () => ({
      transactionDate:
        transactionDetail?.transactionDate ||
        transactionDetail?.valueDate ||
        state?.transactionDate ||
        "-",
      description:
        transactionDetail?.description ||
        transactionDetail?.transactionDescription ||
        state?.description ||
        "-",
      tellerName:
        transactionDetail?.tellerName || transactionDetail?.createdBy || state?.tellerName || "-",
      amount:
        transactionDetail?.amount || transactionDetail?.transactionAmount || state?.amount || "-",
      currencyCode:
        transactionDetail?.currencyCode ||
        transactionDetail?.transactionCurrencyCode ||
        state?.currencyCode ||
        state?.currency ||
        "-",
      transactionStatus: transactionDetail?.status || state?.transactionStatus || "-",
    }),
    [transactionDetail, state],
  );

  const dataSource = [
    { key: "1", description: "Transaction Date", item: detailValues.transactionDate },
    { key: "2", description: "Description", item: detailValues.description },
    { key: "3", description: "Teller Name", item: detailValues.tellerName },
    { key: "4", description: "Amount", item: BOM.FormatAmount(detailValues.amount) },
    { key: "5", description: "Currency Code", item: detailValues.currencyCode },
    { key: "6", description: "Transaction Status", item: detailValues.transactionStatus },
  ];

  const columns = [
    {
      dataIndex: "description",
      key: "description",
      width: "40%",
      onCell: () => ({
        style: {
          backgroundColor: "#F5F5F5",
        },
      }),
      render: (text) => (
        <Text strong style={{ cdolor: "#8C8C8C" }}>
          {text}
        </Text>
      ),
    },
    {
      dataIndex: "item",
      key: "item",
      width: "60%",
    },
  ];

  const currencyOptions = [
    { value: "USD", label: "USD" },
    { value: "EUR", label: "EUR" },
    { value: "KES", label: "KES" },
  ];

  const currencyDenominationOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 200, label: "200" },
    { value: 500, label: "500" },
    { value: 1000, label: "1000" },
  ];

  const denominationColumns = [
    { title: "Currency", dataIndex: "currency", key: "currency" },
    {
      title: "Currency Denomination",
      dataIndex: "currencyDenomination",
      key: "currencyDenomination",
    },
    { title: "Denomination Count", dataIndex: "denominationCount", key: "denominationCount" },
    { title: "Denomination Value", dataIndex: "denominationValue", key: "denominationValue" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="text"
          className="of-primaryBtnColor"
          icon={<DeleteOutlined />}
          onClick={() => handleRemoveDenomination(record)}
        />
      ),
    },
  ];

  const handleRemoveDenomination = (record) => {
    setDenominationEntries(denominationEntries.filter((e) => e.key !== record.key));
  };

  const handleDenominationChange = (value) => {
    setSelectedDenominationValue(Number(value || 0));
    denominationForm.setFieldsValue({
      denominationValue: Number(value || 0) * Number(denominationCount || 0),
    });
  };

  const handleCountChange = (value) => {
    const countValue = Number(value || 0);
    setDenominationCount(countValue);
    denominationForm.setFieldsValue({
      denominationValue: Number(selectedDenominationValue || 0) * countValue,
    });
  };

  const handleAddDenomination = async () => {
    try {
      const values = await denominationForm.validateFields([
        "currencyDenomination",
        "denominationCount",
      ]);

      const denominationValue =
        Number(values.currencyDenomination || 0) * Number(values.denominationCount || 0);

      // const existingEntry = denominationEntries.find((e) => e.currency === transactionCurrency);
      // if (existingEntry) {
      //   BOM.AlertMsg(cnt.DANGER, "Currency already exists");
      //   return;
      // }
      setDenominationEntries((prev) => [
        ...prev,
        {
          key: `${Date.now()}-${prev.length + 1}`,
          currency: transactionCurrency,
          currencyDenomination: values.currencyDenomination,
          denominationCount: values.denominationCount,
          denominationValue,
        },
      ]);

      denominationForm.resetFields(["currencyDenomination", "denominationCount"]);
      setSelectedDenominationValue(0);
      setDenominationCount(0);
    } catch (error) {
      // Form validation handles feedback.
    }
  };

  const handleReceiveTransaction = () => {
    console.log(state, denominationEntries);
    if (
      Number(state?.amount) !==
      Number(denominationEntries.reduce((acc, curr) => acc + curr.denominationValue, 0))
    ) {
      BOM.AlertMsg(cnt.DANGER, "Amount does not match");
      return;
    }
    console.log("receive transaction");
    BOM.AlertMsg(cnt.SUCCESS, "Transaction received successfully");
    setTimeout(() => {
      navigate("/tlo0700");
    }, 1000);
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.tellerTransactionDetail}
        pageItems={staticConfig.tellerTransactionDetailItems}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Form
            onFinish={handleReceiveTransaction}
            form={denominationForm}
            layout="vertical"
            style={{ marginTop: 24 }}
          >
            <Row justify="end" style={{ marginBottom: 12 }}>
              <Button
                className="of-primaryBtnColor"
                style={{
                  width: "10%",
                }}
                onClick={handleReceiveTransaction}
              >
                Receive
              </Button>
              {/* <Button
              className="of-primaryBtnColor"
              style={{
                width: "10%",
                marginLeft: 10,
              }}
              shape="default"
              icon={<CloseSquareOutlined />}
              // htmlType="submit"
              disabled={tellerStatus === "C"}
            >
              Close Till
            </Button> */}
            </Row>
            <Table
              columns={columns}
              dataSource={dataSource}
              pagination={false}
              showHeader={false}
              bordered
            />

            <Divider style={{ marginTop: 8, marginBottom: 16 }} />

            {/* <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 10,
              }}
            >
              Denomination
            </div> */}
            <Title
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 10,
              }}
              level={5}
            >
              Vault Denomination Details
            </Title>
            <Row gutter={16} align="bottom" style={{ marginBottom: 12 }}>
              {/* <Col>
                <Form.Item
                  name="currency"
                  label={<Text strong>Currency</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Currency is required",
                    },
                  ]}
                >
                  <Select style={{ width: "30vh" }} options={currencyOptions} />
                </Form.Item>
              </Col> */}

              <Col span={6}>
                <Form.Item
                  name="currencyDenomination"
                  label={
                    <Text style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
                      Currency Denomination
                    </Text>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Currency denomination is required",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", height: 44 }}
                    placeholder="Select denomination"
                    options={currencyDenominationOptions}
                    onChange={handleDenominationChange}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name="denominationCount"
                  label={
                    <Text style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
                      Denomination count
                    </Text>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Denomination count is required",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%", height: 44, paddingTop: 7 }}
                    onChange={handleCountChange}
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  name="denominationValue"
                  label={
                    <Text style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
                      Denomination value
                    </Text>
                  }
                >
                  <InputNumber
                    style={{ width: "100%", height: 44, paddingTop: 7 }}
                    className="of-bold-disable-input"
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item label=" ">
                  <Button
                    type="primary"
                    className="of-primaryBtnColor"
                    style={{ height: 44 }}
                    onClick={handleAddDenomination}
                  >
                    Add
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            {denominationEntries.length > 0 && (
              <Table
                style={{ marginTop: 16, marginBottom: 24 }}
                dataSource={denominationEntries}
                columns={denominationColumns}
                pagination={false}
                size="small"
              />
            )}
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveTellerTransaction);
